import { createSlice } from '@reduxjs/toolkit';
import { fetchVaultThunk, type FetchVaultResponse } from './thunks/fetch-vault-thunk';

export interface VaultState {
  current: FetchVaultResponse | null;
  isLoading: boolean;
  error: string | null;
}

const initialState: VaultState = {
  current: null,
  isLoading: false,
  error: null,
};

const vaultSlice = createSlice({
  name: 'vault',
  initialState,
  reducers: {
    // Clear current vault
    clearVault: (state) => {
      state.current = null;
      state.error = null;
    },
    // Clear error state
    clearVaultError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // Fetch single vault
      .addCase(fetchVaultThunk.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchVaultThunk.fulfilled, (state, action) => {
        state.isLoading = false;
        state.current = action.payload;
        state.error = null;
      })
      .addCase(fetchVaultThunk.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error.message || 'Failed to fetch vault';
      });
  },
});

export const { clearVault, clearVaultError } = vaultSlice.actions;
export default vaultSlice.reducer;
